/* eslint-disable camelcase */
import dayjs from 'dayjs';
import isSameOrBefore from 'dayjs/plugin/isSameOrBefore';
import { useUiComponentsInternationalContext } from '@rsc/static-translations';

dayjs.extend(isSameOrBefore);

// Need underscore case for recharge data
export const findNumOfMonths = frequencyString => {
  const regex = /\d+/;
  const match = frequencyString.match(regex);
  const num = Number(match[0]);
  return num;
};

export const billingCycleMapping = daysStr => {
  const days = Number.parseInt(daysStr, 10);
  let months;
  if (days >= 0 && days <= 55) {
    months = '1';
  }
  if (days >= 56 && days <= 89) {
    months = '2';
  }
  if (days >= 90 && days <= 119) {
    months = '3';
  }
  if (days >= 120 && days <= 149) {
    months = '4';
  }
  if (days >= 150 && days <= 269) {
    months = '6';
  }
  if (days >= 270 && days <= 360) {
    months = '12';
  }
  return months;
};

export const formatAddress = address => {
  const {
    firstName,
    lastName,
    first_name,
    last_name,
    address1,
    address2,
    city,
    province,
    zip,
    country_code,
  } = address;

  const first = firstName || first_name ? `${firstName ?? first_name} ` : '';
  const last = lastName || last_name ? `${lastName ?? last_name}` : '';
  const name = `${first}${last}, `;
  const street = `${address1}${address2 ? `, ${address2}` : ''}`;

  return `${name}${street}, ${city}, ${province} ${zip}, ${country_code}`;
};

export const convertUsStateToAbbreviation = state => {
  const stateList = {
    Alabama: 'AL',
    Alaska: 'AK',
    Arizona: 'AZ',
    Arkansas: 'AR',
    California: 'CA',
    Colorado: 'CO',
    Connecticut: 'CT',
    'District of Columbia': 'DC',
    Delaware: 'DE',
    Florida: 'FL',
    Georgia: 'GA',
    Hawaii: 'HI',
    Idaho: 'ID',
    Illinois: 'IL',
    Indiana: 'IN',
    Iowa: 'IA',
    Kansas: 'KS',
    Kentucky: 'KY',
    Louisiana: 'LA',
    Maine: 'ME',
    Maryland: 'MD',
    Massachusetts: 'MA',
    Michigan: 'MI',
    Minnesota: 'MN',
    Mississippi: 'MS',
    Missouri: 'MO',
    Montana: 'MT',
    Nebraska: 'NE',
    Nevada: 'NV',
    'New Hampshire': 'NH',
    'New Jersey': 'NJ',
    'New Mexico': 'NM',
    'New York': 'NY',
    'North Carolina': 'NC',
    'North Dakota': 'ND',
    Ohio: 'OH',
    Oklahoma: 'OK',
    Oregon: 'OR',
    Pennsylvania: 'PA',
    'Rhode Island': 'RI',
    'South Carolina': 'SC',
    'South Dakota': 'SD',
    Tennessee: 'TN',
    Texas: 'TX',
    utah: 'UT',
    Vermont: 'VT',
    Virginia: 'VA',
    Washington: 'WA',
    'West Virginia': 'WV',
    Wisconsin: 'WI',
    Wyoming: 'WY',
  };

  return stateList[state];
};

export const capitalizeFirstLetter = word =>
  word.charAt(0).toUpperCase() + word.slice(1);

export const getCurrentPaymentMethod = (
  subscription,
  addresses,
  paymentMethods
) => {
  const paymentMethod = addresses.find(
    address => address?.id === subscription?.address_id
  )?.payment_method_id;
  const payment = paymentMethods.find(pay => pay?.id === paymentMethod);
  return payment;
};

export const getIsCardExpired = paymentDetails => {
  if (paymentDetails === 'undefined') return null;
  const expireDate = `${paymentDetails?.exp_year}-${paymentDetails?.exp_month}-1`;
  const monthCheck = dayjs(expireDate).isSameOrBefore(new Date(), 'month');
  const yearCheck = dayjs(expireDate).isSameOrBefore(new Date(), 'year');
  return !!(monthCheck && yearCheck);
};

export const useDefaultMessages = () => {
  const { tt } = useUiComponentsInternationalContext();

  const errorMessage = tt(s => s.accountDeptComponents.defaultErrorMessage);
  const successMessage = tt(s => s.accountDeptComponents.defaultSuccessMessage);

  return {
    errorMessage,
    successMessage,
  };
};
